export const RECEIVE_PRODUCTION_STEPS = "receive_production_step";
export const PRODUCTION_STEPS_ERROR = "production_step_error";

const receiveProductionStep = workstation => {
	return async dispatch => {
		// no request being made because this maps the result of a socket io connection to the redux store
		const onSuccess = success => {
			dispatch({
				type: RECEIVE_PRODUCTION_STEPS,
				payload: success,
				title: success.productionObject.workStation,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				type: RECEIVE_PRODUCTION_STEPS,
				payload: error,
			});
		};
		try {
			return onSuccess(workstation);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

export { receiveProductionStep };
